(function () {
    const tabs = document.querySelector('[data-tabs]')

    if (tabs) {
        const triggers = tabs.querySelectorAll('[data-tabs-trigger]')
        const targets = tabs.querySelectorAll('[data-tabs-target]')

        if (triggers && targets) {
            triggers.forEach(trigger => {
                trigger.addEventListener('click', e => {
                    e.preventDefault()

                    console.log(e.currentTarget)

                    triggers.forEach(trigger => trigger.classList.remove('active'))
                    e.currentTarget.classList.add('active')

                    const target = e.currentTarget.dataset.tabsTrigger

                    targets.forEach(target => target.classList.remove('active'))
                    tabs.querySelector(`[data-tabs-target=${target}]`).classList.add('active')
                })
            })
        }
    }
}());
